"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _request = require("@/services/request/request.service");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _theme = require("@/mixins/theme/theme");

var _translation = require("@/mixins/translation/translation");

var _autoLogout = require("@/mixins/auto-logout/auto-logout");

var _elementUi = require("element-ui");

var _numberCount = _interopRequireDefault(require("@/components/number-count/number-count.vue"));

var _heatMap = _interopRequireDefault(require("@/components/heat-map/heat-map.vue"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OrderDashboardComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(OrderDashboardComponent, _Mixins);

  var _super = _createSuper(OrderDashboardComponent);

  function OrderDashboardComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, OrderDashboardComponent);
    _this = _super.apply(this, arguments);
    _this.requestParameters = {};
    _this.locations = {};
    _this.summaryData = {};
    _this.code = '';
    _this.dateRange = [];
    return _this;
  }

  (0, _createClass2.default)(OrderDashboardComponent, [{
    key: "onThemeChanges",
    value: function onThemeChanges() {}
  }, {
    key: "latLng",
    get: function get() {
      if (this.summaryData && this.summaryData['latlngList'] && this.summaryData['latlngList'].length >= 1) {
        return (0, _toConsumableArray2.default)(new Set(this.summaryData['latlngList'].reduce(function (finalData, rData) {
          var latLng = rData.split(',');
          finalData.push([latLng[0], latLng[1]]);
          return finalData;
        }, [])));
      } else {
        return [];
      }
    }
  }, {
    key: "beforeCreate",
    value: function beforeCreate() {
      if (!this.request) {
        this.request = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
      }
    }
  }, {
    key: "created",
    value: function created() {
      var _this2 = this;

      this.loading = true;

      if (!this.requestLegacy) {
        this.requestLegacy = new _request.Request('application/json', this.$lfToken || null);
      }

      this.locations = {
        'latitude': this.$userData.latlng.split(',')[0],
        'longitude': this.$userData.latlng.split(',')[1]
      };
      this.requestParameters[process.env.VUE_APP_CUSTOMER_KEY] = this.$userInformation.customerKey || '';
      var dateObj = new Date();
      this.code = dateObj.getFullYear() + '-' + this.helper.pad(dateObj.getMonth() + 1) + '-' + this.helper.pad(dateObj.getDate());
      dateObj.setDate(dateObj.getDate() - 7);
      this.dateRange = ["".concat(dateObj.getFullYear() + '-' + this.helper.pad(dateObj.getMonth() + 1) + '-' + this.helper.pad(dateObj.getDate()), " 00:00:00"), "".concat(this.code, " 23:59:59")];
      /*this.dateRange = [
        '2020-03-01',
        '2020-03-31'
      ];*/

      this.loadCoreInformation(this.dateRange[0], this.dateRange[1]).then(function (summary) {
        if (summary.failed) {
          return Promise.reject('');
        }

        _this2.summaryData = summary.data || {};
        _this2.loading = false;

        _this2.refreshMap();
      }).catch(function (error) {
        _this2.summaryData = {};
        _this2.loading = false;

        _this2.refreshMap();
      });
    }
  }, {
    key: "refreshMap",
    value: function refreshMap() {
      var _this3 = this;

      setTimeout(function () {
        if (_this3.$refs.heatMap) {
          _this3.$refs.heatMap.refreshMap();
        }
      }, 1000);
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "loadCoreInformation",
    value: function loadCoreInformation(startTime, endTime) {
      var param = {
        'dataType': 'order',
        'startTime': startTime,
        'endTime': endTime
      };
      return this.requestLegacy.get('LEGACY_CORE_V3', 'routeplanning/summary', param);
    }
  }, {
    key: "updateDashboard",
    value: function updateDashboard() {
      var _this4 = this;

      var startTime = '';

      if (this.dateRange[0]) {
        var startDate = new Date(this.dateRange[0]);
        startTime = "".concat(startDate.getFullYear() + '-' + this.helper.pad(startDate.getMonth() + 1) + '-' + this.helper.pad(startDate.getDate()), " 00:00:00");
      }

      var endTime = '';

      if (this.dateRange[1]) {
        var endDate = new Date(this.dateRange[1]);
        endTime = "".concat(endDate.getFullYear() + '-' + this.helper.pad(endDate.getMonth() + 1) + '-' + this.helper.pad(endDate.getDate()), " 23:59:59");
      }

      var mapWorld = this.$refs.heatMap;
      this.loadCoreInformation(startTime, endTime).then(function (summary) {
        if (summary.failed) {
          return Promise.reject('');
        }

        _this4.summaryData = summary.data || {};

        if (typeof mapWorld !== 'undefined') {
          mapWorld.refreshMap(_this4.latLng);
        }
      }).catch(function (error) {
        _this4.summaryData = {};

        if (typeof mapWorld !== 'undefined') {
          mapWorld.refreshMap([]);
        }
      });
    }
  }, {
    key: "hasAssemblyMinutes",
    get: function get() {
      var hasAssemblyMinute = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity3', default12)) {
        hasAssemblyMinute = true;
      }

      return hasAssemblyMinute;
    } // duplicated

  }, {
    key: "isChina",
    get: function get() {
      return this.$userSetting['default10'];
    }
  }]);
  return OrderDashboardComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin, _theme.ThemeMixin, _translation.TranslationMixin, _autoLogout.AutoLogoutMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], OrderDashboardComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], OrderDashboardComponent.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], OrderDashboardComponent.prototype, "$lfToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], OrderDashboardComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$isDarkTheme')], OrderDashboardComponent.prototype, "onThemeChanges", null);
OrderDashboardComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'OrderDashboardComponent',
  components: {
    'number-count': _numberCount.default,
    'heat-map': _heatMap.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-card': _elementUi.Card,
    'el-date-picker': _elementUi.DatePicker,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn
  }
})], OrderDashboardComponent);
var _default = OrderDashboardComponent;
exports.default = _default;